export default ( apiInstance: API.Client ) => (uid: string) => (
  apiInstance.Entity.collection( 'patrolCache' ).delete( uid )
);